/**
 * 자체 포인트 시스템 상수
 * - 명칭 변경 시 이 파일만 수정
 */

/** 포인트 명칭 */
export const POINT_NAME = '조각';

/** 포인트 단위 */
export const POINT_UNIT = '개';

/** 환전 최소 포인트 (1개 이상이면 가능) */
export const EXCHANGE_MIN_POINTS = 1;

/** 환전 1회 최대 한도 (원) */
export const EXCHANGE_MAX_POINTS = 1000;

/** 포인트 표시 포맷: "조각 N개" */
export const formatPoint = (amount: number): string => `${POINT_NAME} ${amount}${POINT_UNIT}`;

/** 적립 메시지: "조각 N개를 받았어요!" */
export const earnMessage = (amount: number): string => `${POINT_NAME} ${amount}${POINT_UNIT}를 받았어요!`;
